import type { PromptCode } from '@openclassrooms/js-ai-sdk';
import type { AIServerName } from '../interfaces';

import usePrompt, {
  UsePromptParams,
  UsePromptReturn,
  SDKPromptParameters,
} from '../hooks/usePrompt';

type GetAIHookParams = {
  promptCode: PromptCode;
  serverName?: AIServerName;
};

export type GetAIHookReturn<PromptParams extends SDKPromptParameters | undefined = undefined> = (
  params?: Pick<UsePromptParams, 'shouldStream'>
) => UsePromptReturn<PromptParams>;

export default function getAIHook<
  PromptParams extends SDKPromptParameters | undefined = undefined
>({ promptCode, serverName = 'ai-api-user' }: GetAIHookParams): GetAIHookReturn<PromptParams> {
  return ({ shouldStream } = {}) =>
    usePrompt<PromptParams>({
      promptCode,
      serverName,
      shouldStream,
    });
}
